import { Button, Grid, makeStyles } from "@material-ui/core";
import Accordion from "@material-ui/core/Accordion";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { capitalize } from "lodash";
import React from "react";
import { useHistory } from "react-router-dom";
import theme from "../../assets/theme";
import { AccordionDetails, AccordionSummary } from "./MuiAccordion";
import SubtopicList from "./SubtopicList";
import store from "store";
import { useDispatch } from "react-redux";
import { saveQueryToStore } from "../../redux/actions/practicePageActions/actionCreators";
// import "./TopicList.css";

const useStyle = makeStyles((theme) => ({
  accordionSummaryNoMargin: {
    margin: 0,
    minHeight: 0,
    "&.Mui-expanded": {
      minHeight: 0,
    },
    "& .MuiAccordionSummary-content": {
      margin: 0,
    },
    "& .MuiAccordionSummary-content.Mui-expanded": {
      margin: 0,
    },
  },
  textScroll: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    display: "flex",
    alignItems: "center",
    height: "64px",
    paddingRight: theme.spacing(1),
    maxWidth: "100%",
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.875rem",
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: "1rem",
    },
  },
  // textScrollSubTopic: {
  //   overflow: "hidden",
  //   textOverflow: "ellipsis",
  //   whiteSpace: "nowrap",
  //   display: "flex",
  //   alignItems: "center",
  //   maxWidth: "100%",
  //   paddingRight: theme.spacing(1),
  //   [theme.breakpoints.down("xs")]: {
  //     fontSize: "0.75rem",
  //   },
  // },
  accordionMargin: {
    borderRadius: "12px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
    marginBottom: "12px",
    border: "1px solid rgba(0, 0, 0, 0.04)",
    transition: "all 0.2s ease-in-out",
    "&:hover": {
      boxShadow: "0 4px 16px rgba(0, 0, 0, 0.12)",
      transform: "translateY(-1px)",
    },
    "&:before": {
      background: "none",
    },
  },
  countNumber: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
    width: "52px",
    height: "52px",
    minWidth: "52px",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    fontWeight: "bold",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    [theme.breakpoints.down("xs")]: {
      width: "40px",
      height: "40px",
      minWidth: "40px",
      fontSize: "0.75rem",
    },
  },
  summaryContainer: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    gap: theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      gap: theme.spacing(1),
    },
  },
  titleContainer: {
    flex: 1,
    minWidth: 0,
    display: "flex",
    alignItems: "center",
  },
  resumeText: {
    marginLeft: theme.spacing(1),
    padding: theme.spacing(0.5, 1),
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.contrastText,
    borderRadius: theme.spacing(1),
    fontSize: "0.65rem",
    fontWeight: "bold",
  },
  accordionDetailsContainer: {
    height: "auto",
    overflowY: "auto",
    overflowX: "hidden",
    padding: theme.spacing(0.5, 0),
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
      borderRadius: "3px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#c1c1c1",
      borderRadius: "3px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#a8a8a8",
    },
  },
}));

function TopicList({ count, titleName, subTopics, subject, percentData }) {
  const classes = useStyle();
  const history = useHistory();
  const dispatch = useDispatch();
  let user = store.get("user");
  const handleOnClick = (event, topic = "", subTopic = "") => {
    const body = {
      student_id: user._id,
      instituteId: "5d679d49c136660a09596d85", //user.institute,
      subject: subject,
      topic: topic,
      subTopic: subTopic,
    };
    store.set("practice" + subject + "topic", topic);
    store.set("practice" + subject + "subTopic", subTopic);
    dispatch(saveQueryToStore(body));
    history.push(`/practice/${subject}`, body);
  };
  return (
    <div className="topic-list-enhanced">
      {subTopics[0] === "EMPTY" ? (
        <div className={classes.accordionMargin}>
          <AccordionSummary
            className={classes.accordionSummaryNoMargin}
            expandIcon={
              store.get("practice" + store.get("practiceSubject") + "topic") ===
              titleName ? (
                <Button
                  disableRipple
                  size="small"
                  color="primary"
                  variant="contained"
                  onClick={(event) => handleOnClick(event, titleName)}
                >
                  Resume
                </Button>
              ) : (
                <Button
                  disableRipple
                  size="small"
                  color="primary"
                  variant="outlined"
                  onClick={(event) => handleOnClick(event, titleName)}
                >
                  Start
                </Button>
              )
            }
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <div className={classes.summaryContainer}>
              <Typography className={classes.countNumber} variant="subtitle2">
                {count}
              </Typography>
              <div className={classes.titleContainer}>
                <Typography
                  className={classes.textScroll}
                  variant="subtitle1"
                  title={capitalize(titleName)}
                >
                  {capitalize(titleName)}
                </Typography>
              </div>
            </div>
          </AccordionSummary>
        </div>
      ) : (
        <Accordion
          TransitionProps={{ unmountOnExit: true }}
          className={classes.accordionMargin}
        >
          <AccordionSummary
            className={classes.accordionSummaryNoMargin}
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <div className={classes.summaryContainer}>
              <Typography className={classes.countNumber} variant="subtitle2">
                {count}
              </Typography>
              <div className={classes.titleContainer}>
                <Typography
                  className={classes.textScroll}
                  variant="subtitle1"
                  title={capitalize(titleName)}
                >
                  {capitalize(titleName)}
                </Typography>
                {store.get(
                  "practice" + store.get("practiceSubject") + "topic"
                ) === titleName && (
                  <Typography variant="caption" className={classes.resumeText}>
                    Resume
                  </Typography>
                )}
              </div>
            </div>
          </AccordionSummary>
          <AccordionDetails className={classes.accordionDetailsContainer}>
            <Grid container direction="column">
              {subTopics.map((subtopic, index) => {
                const percent =
                  percentData &&
                  percentData.subTopicWisePercent[titleName] &&
                  percentData.subTopicWisePercent[titleName][subtopic]
                    ? percentData.subTopicWisePercent[titleName][subtopic]
                    : 0;
                return (
                  <SubtopicList
                    subtopic={subtopic}
                    key={subtopic}
                    topicName={titleName}
                    index={index}
                    percentage={percent}
                    textScrollClass={classes.textScrollSubTopic}
                    handleClick={(event) =>
                      handleOnClick(event, titleName, subtopic)
                    }
                  />
                );
              })}
            </Grid>
          </AccordionDetails>
        </Accordion>
      )}
    </div>
  );
}
export default TopicList;
